// src/pages/SettingsPage/SettingsPage.tsx
import { Stack } from "@mui/material";
import React from "react";
import { NotePageContainer } from "../note";
import { useUserIsOwner } from "../../hook/role";
import { useIsAppOwner } from "../../hook/settings";
import { GlobalAdminWorkspaceTable } from "./settings/GlobalAdminWorkSpaceTable";
import { GlobalAdminWorkspaceUserTable } from "./settings/GlobalAdminWorkSpaceUserTable";
import { WorkspaceAdminPaymentSettings } from "./settings/WorkSpaceAdminPaymentSettings";
import { WorkspaceSubscriptionSettings } from "./settings/WorkSpaceSubscriptionSettings";
import { WorkspaceTable } from "./settings/WorkSpaceTable";
import { WorkspaceUserTable } from "./settings/WorkSpaceUserTable";
import { StaticHtmlBlock } from "../staticHtmlBlock";
import { ModelProviderSettings } from "../settings/ModelProviderSettings";

export const SettingsPage: React.FC = () => {
  const isOwner = useUserIsOwner();
  const isAppOwner = useIsAppOwner();

  const showWorkspaceSettings = true;
  const showSubscriptionSettings = true;
  const showGlobalAdminSettings = isOwner;

  return (
    <Stack gap={3}>
      {showWorkspaceSettings && (
        <NotePageContainer pageName="Workspace Settings">
          <StaticHtmlBlock html="<p>Your workspaces are listed below. Select one to make it active. Each workspace has its own data and subscription.</p>" />
          <WorkspaceTable />
          <WorkspaceUserTable />
          <></>
        </NotePageContainer>
      )}

      {showSubscriptionSettings && (
        <NotePageContainer pageName="Subscription Settings">
          {isAppOwner && <WorkspaceAdminPaymentSettings />}
          <WorkspaceSubscriptionSettings />
          <></>
        </NotePageContainer>
      )}

      <NotePageContainer pageName="Agent Provider">
        <ModelProviderSettings />
      </NotePageContainer>

      {showGlobalAdminSettings && (
        <NotePageContainer pageName="Global Admin Settings">
          <GlobalAdminWorkspaceTable />
          <GlobalAdminWorkspaceUserTable />
          <></>
        </NotePageContainer>
      )}
      <></>
    </Stack>
  );
};
